// removed by extract-text-webpack-plugin
module.exports = {"aws-package":"packageselector-module__aws-package___1_O2X","option":"packageselector-module__option___3zLYC","option-price":"packageselector-module__option-price___3i5De"};


//////////////////
// WEBPACK FOOTER
// ./src/components/packageselector.module.scss
// module id = 299
// module chunks = 1